import { render, staticRenderFns } from "./NewConferenceForm.vue?vue&type=template&id=9406b64e"
import script from "./NewConferenceForm.vue?vue&type=script&lang=js"
export * from "./NewConferenceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports